import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ListGroup } from 'react-bootstrap';
import { fetchLaneNames, actions as machineActions } from './store/slice';
import '../../style/scss/main.scss';
import { selectCellLaneData } from './store/selectors';

const { setLane } = machineActions;

const MachineNavBar = ({ data, activeLane, onLaneChange }) => {
  const dispatch = useDispatch();

  //const lanes = useSelector(selectCellLaneData);
  const lanes = useSelector(selectCellLaneData) || [];
  const filteredLanes = lanes.length > 1 ? lanes : lanes.filter(lane => lane !== 'ALL');

  const handleLane = lane => {
    onLaneChange(lane);
    dispatch(setLane(lane));
  };

  return (
    <div className="lane-list-container">
      <ListGroup className="lane-list">
        {/* {lanes.map(lane => ( */}
        {filteredLanes.length > 0 &&
          filteredLanes.map(lane => (
            <ListGroup.Item
              key={lane}
              action
              onClick={() => handleLane(lane)}
              className={`lane-item ${lane === activeLane ? 'active' : ''}`}
            >
              <Link to="#" className="lane-link">
                {lane}
              </Link>
            </ListGroup.Item>
          ))}
      </ListGroup>
    </div>
  );
};

export default MachineNavBar;
